<template>
	<a-layout-sider class="layout-sider" width="260">
			<left-menu/>
	</a-layout-sider>
</template>

<script>
import LeftMenu from "@/layout/layoutPage/aside/LeftMenu";

export default {
	name: "LayoutSider",
	components: {
			LeftMenu
	},
	data() {
			return {
			}
	}
}
</script>

<style scoped>
.layout-sider {
	background-color: #fff;
	overflow-y: auto;
	overflow-x: hidden;
	margin: 11px 0;
}
.logo {
	color: #ffffff;
	padding: 15px;
	font-size: 24px;
	color: #000;
}
</style>
